module.exports = __webpack_public_path__ + "static/media/sweat-royal.f624ab5c.svg";